import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { appActions } from '../actions/appAction';

export interface AppState {
    id: string;
    name: string;
    email: string;
    accountid: string;
    govName: string;
    govNameSuffix: string;
    userGroupId: string;
    startDate: string;
    role: string;
    idid: string;
    loading: boolean;
}

const initialState: AppState = {
    id: 'ABCD',
    name: '',
    email: 'test@test.co.jp',
    accountid: 'xxxxssss',
    govName: '',
    govNameSuffix: '',
    userGroupId: '-1',
    startDate: '',
    role: 'Viewer',
    idid: 'qwerty',
    loading: false,
};

export const appReducer = reducerWithInitialState(initialState)
    .case(appActions.initViewer, (state, payload) => {
        return Object.assign({}, state, {
            id: payload.id, name: payload.name,
            email: payload.email, accountid: payload.accountid, startDate: payload.startDate, govName: payload.govName, govNameSuffix: payload.govNameSuffix,
            userGroupId: payload.userGroupId, role: payload.role, idid: payload.idid,
        });
    }).case(appActions.setLoading, (state, payload) => {
        return Object.assign({}, state, { loading: payload });
    });
